import { Action } from '@ngrx/store';
import { IOfferLine, ShoppingCartError } from '~shared/modules/cart/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { CartActionTypes } from '~shared/modules/shopping-cart-global/store';
import { CartOfferLine, StoreCart } from '../models';

export enum ShoppingCartActionTypes {
  READ_SHOPPING_CART = '[app-checkout/shopping-cart-store] Read shopping cart',
  READ_SHOPPING_CART_SUCCESS = '[app-checkout/shopping-cart-store] Read shopping cart Success',
  READ_SHOPPING_CART_FAILURE = '[app-checkout/shopping-cart-store] Read shopping cart Failure',

  READ_PARTIAL_SHOPPING_CART = '[app-checkout/shopping-cart-store] Read partial shopping cart',

  UPDATE_QUANTITY = "[app-checkout/cart-store] Update product's quantity in the shopping cart",
  UPDATE_QUANTITY_SUCCESS = "[app-checkout/shopping-cart-store] Update product's quantity in the shopping cart Success",
  UPDATE_QUANTITY_FAILURE = "[app-checkout/shopping-cart-store] Update product's quantity in the shopping cart Failure",

  DELETE_PRODUCT = '[app-checkout/shopping-cart-store] Delete product from the shopping cart',
  DELETE_PRODUCT_FROM_MINI_CART = '[app-checkout/shopping-cart-store] Delete product from the mini shopping cart',
  DELETE_PRODUCT_SUCCESS = '[app-checkout/shopping-cart-store] Delete product from the shopping cart Success',
  DELETE_PRODUCT_FAILURE = '[app-checkout/shopping-cart-store] Delete product from the shopping cart Failure',

  DELETE_VALUE_ADDED_SERVICE = '[app-checkout/shopping-cart-store] Delete value added service from the shopping cart',
  DELETE_VALUE_ADDED_SERVICE_SUCCESS = '[app-checkout/shopping-cart-store] Delete value added service from the shopping cart Success',
  DELETE_VALUE_ADDED_SERVICE_FAILURE = '[app-checkout/shopping-cart-store] Delete value added service from the shopping cart Failure',

  PROCEED_TO_CHECKOUT = '[app-checkout/shopping-cart-store] Proceed to checkout',
  PROCEED_TO_CHECKOUT_SUCCESS = '[app-checkout/shopping-cart-store] Proceed to checkout Success',
  PROCEED_TO_CHECKOUT_FAILURE = '[app-checkout/shopping-cart-store] Proceed to checkout Failure',

  APPLY_DISCOUNT_CODE = '[app-checkout/shopping-cart-store] Apply Discount Code',
  APPLY_DISCOUNT_CODE_SUCCESS = '[app-checkout/shopping-cart-store] Apply Discount Code Success',
  APPLY_DISCOUNT_CODE_FAILURE = '[app-checkout/shopping-cart-store] Apply Discount Code Failure',
  DELETE_DISCOUNT_CODE = '[app-checkout/shopping-cart-store] Remove Discount Code',

  UPDATE_CART = '[app-checkout/shopping-cart-store] Update cart',
  UPDATE_CART_SUCCESS = '[app-checkout/shopping-cart-store] Update cart Success',
  UPDATE_CART_FAILURE = '[app-checkout/shopping-cart-store] Update cart Failure',
}

export class ReadPartialShoppingCart implements Action {
  readonly type = ShoppingCartActionTypes.READ_PARTIAL_SHOPPING_CART;

  constructor(public payload: { accountType: PriceTypes; actionType?: ShoppingCartActionTypes }) {}
}

export class ReadShoppingCart implements Action {
  readonly type = ShoppingCartActionTypes.READ_SHOPPING_CART;

  constructor(public payload?: { actionType?: CartActionTypes }) {}
}

export class ReadShoppingCartSuccess implements Action {
  readonly type = ShoppingCartActionTypes.READ_SHOPPING_CART_SUCCESS;

  constructor(public payload: StoreCart, public actionType?: CartActionTypes | ShoppingCartActionTypes) {}
}

export class ReadShoppingCartFailure implements Action {
  readonly type = ShoppingCartActionTypes.READ_SHOPPING_CART_FAILURE;

  constructor(public payload: ShoppingCartError) {}
}

export class UpdateQuantity implements Action {
  readonly type = ShoppingCartActionTypes.UPDATE_QUANTITY;

  constructor(public payload: { cartLine: CartOfferLine; quantity: number; accountType: PriceTypes }) {}
}

export class UpdateQuantitySuccess implements Action {
  readonly type = ShoppingCartActionTypes.UPDATE_QUANTITY_SUCCESS;

  constructor(public payload: IOfferLine) {}
}

export class UpdateQuantityFailure implements Action {
  readonly type = ShoppingCartActionTypes.UPDATE_QUANTITY_FAILURE;

  constructor(public payload: { id: string; error: ShoppingCartError }) {}
}

export class DeleteProduct implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_PRODUCT;

  constructor(
    public payload: {
      id: string;
      offerLine: IOfferLine;
      accountType: PriceTypes;
      cartLineId: string;
      hasToStoreNotification?: boolean;
    }
  ) {}
}

export class DeleteProductFromMiniCart implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_PRODUCT_FROM_MINI_CART;

  constructor(public payload: { cartLineId: string; id: string; offerLine: IOfferLine; accountType: PriceTypes }) {}
}

export class DeleteProductSuccess implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_PRODUCT_SUCCESS;

  constructor(public payload: { id: string; offerLine: IOfferLine; accountType: PriceTypes; fromMiniCart?: boolean }) {}
}

export class DeleteProductFailure implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_PRODUCT_FAILURE;

  constructor(public payload: { id: string; error: ShoppingCartError }) {}
}

export class DeleteValueAddedService implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_VALUE_ADDED_SERVICE;

  constructor(public payload: { vasId: string; offerId: string; accountType: PriceTypes }) {}
}

export class DeleteValueAddedServiceSuccess implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_VALUE_ADDED_SERVICE_SUCCESS;

  constructor(public payload: { vasId: string; offerId: string; accountType: PriceTypes }) {}
}

export class DeleteValueAddedServiceFailure implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_VALUE_ADDED_SERVICE_FAILURE;

  constructor(public payload: { id: string; error: ShoppingCartError }) {}
}

export class ProceedToCheckout implements Action {
  readonly type = ShoppingCartActionTypes.PROCEED_TO_CHECKOUT;

  constructor(public payload: { force: boolean } = { force: false }) {}
}

export class ProceedToCheckoutSuccess implements Action {
  readonly type = ShoppingCartActionTypes.PROCEED_TO_CHECKOUT_SUCCESS;

  constructor() {}
}

export class ProceedToCheckoutFailure implements Action {
  readonly type = ShoppingCartActionTypes.PROCEED_TO_CHECKOUT_FAILURE;

  constructor(public payload: any) {}
}

export class ApplyDiscountCode implements Action {
  readonly type = ShoppingCartActionTypes.APPLY_DISCOUNT_CODE;

  constructor(public payload: string) {}
}

export class ApplyDiscountCodeSuccess implements Action {
  readonly type = ShoppingCartActionTypes.APPLY_DISCOUNT_CODE_SUCCESS;

  constructor(public payload: StoreCart) {}
}

export class ApplyDiscountCodeFailure implements Action {
  readonly type = ShoppingCartActionTypes.APPLY_DISCOUNT_CODE_FAILURE;

  constructor(public payload: ShoppingCartError) {}
}

export class DeleteDiscountCode implements Action {
  readonly type = ShoppingCartActionTypes.DELETE_DISCOUNT_CODE;
}

export class UpdateCart implements Action {
  readonly type = ShoppingCartActionTypes.UPDATE_CART;

  constructor(public payload: { discountCode: string | null }) {}
}

export class UpdateCartSuccess implements Action {
  readonly type = ShoppingCartActionTypes.UPDATE_CART_SUCCESS;

  constructor(public payload: StoreCart) {}
}

export class UpdateCartFailure implements Action {
  readonly type = ShoppingCartActionTypes.UPDATE_CART_FAILURE;

  constructor(public payload: any) {}
}

export type ShoppingCartsActions =
  | ReadPartialShoppingCart
  | ReadShoppingCart
  | ReadShoppingCartSuccess
  | ReadShoppingCartFailure
  | UpdateQuantity
  | UpdateQuantitySuccess
  | UpdateQuantityFailure
  | DeleteProduct
  | DeleteProductFromMiniCart
  | DeleteProductSuccess
  | DeleteProductFailure
  | DeleteValueAddedService
  | DeleteValueAddedServiceSuccess
  | DeleteValueAddedServiceFailure
  | ProceedToCheckout
  | ProceedToCheckoutSuccess
  | ProceedToCheckoutFailure
  | ApplyDiscountCode
  | ApplyDiscountCodeSuccess
  | ApplyDiscountCodeFailure
  | DeleteDiscountCode
  | UpdateCart
  | UpdateCartSuccess
  | UpdateCartFailure;
